import React from 'react'

const ContactImage = () => {
  return (
    <>
      <svg
      className='md:w-80 w-44'
        width="512"
        height="1024"
        viewBox="0 0 512 1024"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M253.106 769.203L213.522 787.083C198.653 783.153 201.884 763.467 201.884 763.467L147.318 655.068C140.064 640.603 146.304 623.008 161.052 616.347C175.799 609.685 193.125 616.635 199.184 631.639L245.27 746.116C245.27 746.116 260.6 756.073 253.106 769.203Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M226.437 853.411L273.505 827.958L252.691 769.581L214.816 786.69L234.547 821.898L222.021 849.28C220.747 852.063 223.746 854.866 226.437 853.411Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M144.984 645.961C143.112 630.876 153.406 616.977 169.881 614.368L317.206 588.705C335.887 585.189 354.904 599.272 357.426 619.6C359.949 639.928 344.952 658.233 324.523 659.755L175.393 670.878C160.234 672.009 146.856 661.047 144.984 645.961Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M171.11 787.759L129.269 776.105C120.375 763.556 135.476 750.518 135.476 750.518L163.092 632.345C166.797 616.594 182.867 607.09 198.455 611.432C214.044 615.773 222.887 632.215 217.917 647.614L179.897 765.016C179.897 765.016 185.277 782.486 171.11 787.759Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M96.6583 835.289L149.098 845.93L170.55 787.784L130.515 776.633L123.085 816.303L95.9173 829.287C93.1558 830.606 93.6583 834.68 96.6583 835.289Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M139.862 590.998C164.672 584.659 223.503 572.275 255.564 557.937C255.564 557.937 288.606 542.167 274.682 513.091C261.107 484.74 228.144 502.48 228.144 502.48C190.832 521.538 147.726 545.161 126.551 555.072C126.551 555.072 115.461 560.938 119.555 576.037C124.412 593.955 139.862 590.998 139.862 590.998Z"
          fill="#EFADAB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M219.411 519.214C219.411 519.214 211.308 452.952 211.435 441.052C211.546 430.642 214.786 403.38 242.94 401.548C265.452 400.084 275.122 417.63 278.496 431.775C284.323 456.213 282.015 487.708 279.777 516.355C279.777 516.355 278.358 548.973 246.958 547.504C220.387 546.264 219.411 519.214 219.411 519.214Z"
          fill="#EFADAB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M215.735 485.266C214.652 474.497 210.233 444.785 210.271 441.035C210.384 430.625 215.055 401.933 243.207 400.102C265.719 398.638 275.391 417.613 278.765 431.759C281.09 441.511 281.556 472.036 281.811 483.406L215.735 485.266Z"
          fill="#597EF7"
        />
        <path
          d="M211.66 439.682C211.963 439.686 212.207 439.934 212.203 440.237L212.21 440.698C212.325 444.465 213.83 461.281 215.377 477.184L216.179 485.317L281.736 482.054C282.009 482.04 282.244 482.228 282.3 482.486L282.312 482.575C282.325 482.847 282.138 483.083 281.879 483.139L281.791 483.15L215.713 486.44C215.42 486.454 215.168 486.237 215.139 485.946L213.88 473.107C212.403 457.701 211.08 442.629 211.105 440.226C211.109 439.922 211.357 439.679 211.66 439.682Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M366.774 540.542C366.774 540.542 393.952 419.56 388.452 408.557C382.95 397.553 356.946 384.991 312.108 385.895C250.33 387.142 232.102 400.969 232.102 400.969C232.102 400.969 247.189 479.933 260.482 527.656C253.48 540.16 262.971 553.919 262.971 553.919C262.971 553.919 342.865 550.226 361.87 551.225C370.746 547.421 366.774 540.542 366.774 540.542Z"
          fill="#597EF7"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M255.201 639.557L306.095 654.359L373.388 635.352C373.388 635.352 383.523 616.77 363.534 563.588C360.999 556.614 359.969 551.384 359.969 551.384C359.969 551.384 299.265 553.4 262.971 553.92L261.702 565.331C261.702 565.331 250.346 589.74 250.346 602.411C250.346 626.144 255.201 639.557 255.201 639.557Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M327.73 383.144L315.964 323.057L270.73 330.644L271.533 388.739L289.965 415.183L327.73 383.144Z"
          fill="#FFC2BD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M294.65 294.604C294.65 294.604 264.688 291.341 258.841 305.983C253.156 320.224 259.633 367.709 275.75 372.698C288.887 376.763 313.529 370.319 316.105 346.546C316.105 346.546 318.527 328.244 314.329 312.844C310.13 297.443 294.65 294.604 294.65 294.604Z"
          fill="#FFC2BD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M314.066 332.749C314.066 332.749 319.68 316.539 326.844 323.812C334.007 331.084 326.196 347.619 317.324 348.289C308.45 348.96 314.066 332.749 314.066 332.749Z"
          fill="#FFC2BD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M257.856 334.007C257.856 334.007 251.405 316.376 254.127 304.437C256.85 292.5 260.825 280.377 265.782 285.732C265.992 282.818 268.92 276.617 271.466 274.319C274.01 272.019 284.597 282.951 284.597 282.951C284.597 282.951 283.136 277.4 287.094 280.34C291.054 283.28 313.64 290.835 317.922 295.971C322.206 301.106 323.441 322.127 323.441 322.127C323.441 322.127 316.605 322.496 314.9 335.885C314.31 325.398 309.204 320.625 306.689 318.894C305.735 318.239 305.094 317.225 304.838 316.097C304.347 313.928 303.557 310.286 302.933 306.704C302.658 305.126 301.307 303.986 299.705 303.947C283.4 303.543 266.288 308.601 260.222 310.595C258.851 311.045 257.94 312.335 257.96 313.778L258.131 325.77C258.131 325.77 257.603 327.956 257.856 334.007Z"
          fill="#253368"
        />
        <path
          d="M295.864 324.082L296.001 324.09L301.512 324.715C302.207 324.794 302.706 325.422 302.627 326.117C302.553 326.769 301.997 327.248 301.355 327.241L301.226 327.233L295.991 326.638L286.348 329.832C285.726 330.038 285.057 329.734 284.795 329.148L284.748 329.027C284.541 328.405 284.845 327.736 285.431 327.473L285.552 327.426L295.46 324.146C295.59 324.103 295.727 324.081 295.864 324.082Z"
          fill="#253368"
        />
        <path
          d="M264.788 327.552L264.923 327.56L275.351 328.742C276.046 328.82 276.546 329.448 276.467 330.143C276.393 330.795 275.837 331.275 275.195 331.267L275.065 331.259L264.982 330.115L261.537 331.652C260.938 331.919 260.242 331.684 259.923 331.127L259.864 331.011C259.597 330.412 259.832 329.717 260.389 329.397L260.505 329.338L264.264 327.661C264.429 327.588 264.608 327.55 264.788 327.552Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M314.488 338.855C314.488 338.855 307.318 346.379 304.057 353.59C297.101 347.168 290.444 344.947 290.444 344.947C290.444 344.947 284.119 351.274 280.112 350.183C278.729 348.946 278.644 347.492 278.644 347.492C278.644 347.492 272.642 350.782 269.146 358.028C266.569 353.602 260.368 348.295 260.368 348.295C260.368 348.295 263.779 379.168 286.426 376.301C309.239 372.931 314.978 359.185 316.001 348.22C316.109 344.815 315.787 336.26 314.488 338.855Z"
          fill="#EFADAB"
        />
        <path
          d="M295.209 349.378C295.694 349.099 296.314 349.266 296.593 349.751C296.872 350.236 296.705 350.855 296.22 351.134L295.869 351.327L295.426 351.56C295.268 351.642 295.1 351.727 294.922 351.815C293.908 352.315 292.781 352.815 291.569 353.282C288.168 354.59 284.764 355.391 281.553 355.428C280.545 355.439 279.57 355.374 278.631 355.226C278.078 355.139 277.701 354.62 277.788 354.068C277.875 353.515 278.393 353.137 278.946 353.224C279.769 353.354 280.632 353.412 281.53 353.401C284.466 353.367 287.647 352.619 290.841 351.39C291.993 350.947 293.064 350.472 294.024 349.998L294.497 349.759L295.126 349.424C295.162 349.405 295.19 349.389 295.209 349.378Z"
          fill="#D18888"
        />
        <path
          d="M277.812 329.662C278.181 329.573 278.553 329.773 278.687 330.118L278.718 330.215L279.541 333.617C279.559 333.692 279.566 333.769 279.56 333.846L279.524 334.422L279.459 335.639C279.453 335.749 279.448 335.86 279.443 335.973C279.35 338.018 279.305 340.093 279.334 342.024L279.348 342.715C279.449 346.558 279.895 349.199 280.481 349.531C281.019 349.834 282.438 349.419 284.325 348.359C284.903 348.034 285.512 347.658 286.142 347.242C286.955 346.703 287.761 346.125 288.521 345.547L289.241 344.989C289.367 344.889 289.455 344.818 289.499 344.782C289.82 344.519 290.292 344.565 290.555 344.886C290.818 345.206 290.771 345.678 290.451 345.941L290.173 346.164L289.63 346.588C289.565 346.638 289.498 346.689 289.429 346.742C288.644 347.338 287.813 347.935 286.97 348.492C286.312 348.928 285.672 349.323 285.06 349.667C282.707 350.989 280.932 351.508 279.744 350.837C278.383 350.068 277.909 347.056 277.834 342.047C277.805 340.081 277.85 337.978 277.944 335.905L278.01 334.622L278.056 333.856L277.26 330.568C277.17 330.199 277.371 329.827 277.715 329.693L277.812 329.662Z"
          fill="#D18888"
        />
        <path
          d="M288.357 358.782C288.767 358.723 289.147 359.008 289.205 359.418C289.259 359.794 289.024 360.144 288.669 360.245L288.569 360.266L283.283 361.022C282.873 361.081 282.493 360.796 282.434 360.386C282.381 360.01 282.616 359.66 282.971 359.559L283.071 359.538L288.357 358.782Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M291.365 336.264C291.634 338.082 292.904 339.401 294.205 339.209C295.502 339.017 296.338 337.388 296.069 335.57C295.801 333.75 294.53 332.432 293.231 332.624C291.932 332.816 291.097 334.446 291.365 336.264Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M266.671 339.913C266.939 341.731 268.21 343.05 269.51 342.858C270.808 342.666 271.643 341.037 271.375 339.219C271.106 337.399 269.834 336.081 268.537 336.273C267.236 336.465 266.402 338.095 266.671 339.913Z"
          fill="#253368"
        />
        <path
          d="M293.487 347.486C293.711 347.184 294.12 347.099 294.442 347.271L294.536 347.331L299.216 350.805C299.549 351.052 299.618 351.521 299.371 351.854C299.147 352.156 298.738 352.241 298.416 352.069L298.322 352.009L293.642 348.535C293.31 348.288 293.24 347.818 293.487 347.486Z"
          fill="#D18888"
        />
        <path
          d="M315.903 348.445L316.005 348.452C316.416 348.507 316.704 348.884 316.648 349.295L316.598 349.616L316.526 350.021C316.499 350.165 316.468 350.319 316.435 350.481C316.244 351.405 315.986 352.433 315.651 353.538C314.695 356.695 313.313 359.851 311.426 362.802C304.26 374.002 292.102 379.154 273.885 374.878C273.482 374.783 273.232 374.379 273.326 373.976C273.421 373.573 273.825 373.323 274.228 373.417C291.817 377.546 303.335 372.665 310.162 361.993C311.97 359.168 313.297 356.136 314.215 353.103C314.491 352.194 314.712 351.341 314.884 350.562L314.966 350.178C315.074 349.654 315.136 349.284 315.162 349.095C315.212 348.719 315.534 348.445 315.903 348.445Z"
          fill="#D18888"
        />
        <path
          d="M286.004 366.018C286.169 365.638 286.611 365.463 286.991 365.628C287.371 365.793 287.545 366.234 287.381 366.614L287.319 366.77C287.261 366.925 287.188 367.146 287.114 367.418C286.829 368.473 286.741 369.56 286.96 370.548C287.242 371.82 288.013 372.815 289.431 373.481C289.806 373.657 289.967 374.103 289.791 374.478C289.615 374.853 289.168 375.015 288.793 374.839C286.946 373.972 285.877 372.591 285.495 370.873C285.216 369.613 285.323 368.295 285.667 367.026L285.772 366.663C285.859 366.383 285.941 366.165 286.004 366.018Z"
          fill="#D18888"
        />
        <path
          d="M322.284 327.788C324.111 326.758 325.377 327.336 325.859 328.84C325.993 329.258 326.048 329.669 326.06 330.004L326.062 330.165C326.056 330.522 325.769 330.802 325.419 330.796C325.102 330.792 324.842 330.554 324.801 330.248L324.796 330.154L324.793 330.028C324.783 329.8 324.743 329.506 324.653 329.227C324.406 328.456 324.003 328.272 322.906 328.891C320.886 330.031 320.898 331.632 322.273 334.96C323.423 337.747 322.517 339.87 319.84 340.829C319.511 340.947 319.149 340.776 319.031 340.446C318.913 340.117 319.084 339.755 319.413 339.637C321.402 338.925 321.98 337.569 321.103 335.444C319.508 331.582 319.492 329.365 322.284 327.788Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M292.999 357.626C293.099 357.938 293.435 358.111 293.747 358.01C294.059 357.91 294.23 357.575 294.13 357.263C294.029 356.95 293.695 356.779 293.383 356.879C293.071 356.98 292.898 357.314 292.999 357.626Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M302.153 358.535C302.254 358.847 302.588 359.02 302.902 358.919C303.214 358.819 303.385 358.483 303.284 358.171C303.184 357.859 302.849 357.688 302.537 357.787C302.225 357.887 302.053 358.223 302.153 358.535Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M274 364.66C273.932 364.981 274.136 365.296 274.457 365.365C274.78 365.433 275.095 365.229 275.162 364.908C275.231 364.587 275.026 364.27 274.705 364.203C274.384 364.134 274.069 364.339 274 364.66Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M268.066 362.664C267.999 362.985 268.203 363.3 268.524 363.369C268.846 363.438 269.161 363.233 269.229 362.912C269.298 362.591 269.092 362.274 268.771 362.207C268.45 362.138 268.135 362.343 268.066 362.664Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M279.042 365.665C278.973 365.986 279.179 366.301 279.5 366.37C279.821 366.437 280.136 366.233 280.205 365.912C280.272 365.591 280.068 365.275 279.747 365.207C279.426 365.138 279.11 365.344 279.042 365.665Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M285.704 363.302C285.637 363.623 285.841 363.938 286.162 364.007C286.483 364.075 286.798 363.871 286.867 363.55C286.934 363.229 286.73 362.912 286.409 362.845C286.088 362.776 285.772 362.981 285.704 363.302Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M308.645 355.105C308.578 355.426 308.782 355.742 309.103 355.81C309.424 355.879 309.739 355.673 309.808 355.352C309.877 355.031 309.671 354.716 309.35 354.647C309.029 354.578 308.713 354.784 308.645 355.105Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M298.654 365.223C298.755 365.535 299.089 365.708 299.403 365.607C299.715 365.507 299.886 365.172 299.785 364.86C299.685 364.547 299.35 364.376 299.038 364.476C298.725 364.577 298.554 364.911 298.654 365.223Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M293.957 364.986C294.058 365.298 294.394 365.471 294.706 365.37C295.018 365.27 295.19 364.935 295.09 364.622C294.988 364.31 294.653 364.139 294.341 364.238C294.029 364.338 293.857 364.674 293.957 364.986Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M275.767 369.292C275.867 369.604 276.203 369.776 276.515 369.676C276.827 369.575 277 369.241 276.898 368.927C276.797 368.615 276.463 368.444 276.151 368.543C275.839 368.644 275.666 368.98 275.767 369.292Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M277.659 361.915C277.76 362.227 278.094 362.399 278.406 362.299C278.72 362.198 278.891 361.864 278.79 361.55C278.69 361.238 278.355 361.067 278.043 361.166C277.73 361.267 277.559 361.603 277.659 361.915Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M274.673 356.348C274.774 356.66 275.11 356.832 275.422 356.732C275.734 356.631 275.905 356.297 275.804 355.983C275.704 355.671 275.369 355.5 275.057 355.599C274.745 355.701 274.573 356.036 274.673 356.348Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M303.274 362.115C303.374 362.427 303.709 362.599 304.022 362.499C304.334 362.398 304.505 362.064 304.405 361.75C304.304 361.438 303.97 361.267 303.658 361.366C303.344 361.467 303.173 361.803 303.274 362.115Z"
          fill="#D18888"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M266.689 402.794L270.73 381.644L279.841 381.241L292.355 404.345L300.22 379.837L328.028 373.232L335.555 389.701C335.555 389.701 325.031 414.499 291.275 415.001C274.6 415.25 266.689 402.794 266.689 402.794Z"
          fill="#597EF7"
        />
        <path
          d="M240.038 436.07C240.319 436.016 240.591 436.176 240.687 436.436L240.734 436.641L241.276 439.399L242.186 443.946C242.801 446.997 243.476 450.288 244.203 453.77C246.901 466.704 249.758 479.639 252.647 491.709L253.517 495.316C255.444 503.228 257.316 510.443 259.112 516.821L259.658 518.742C260.563 521.896 261.443 524.814 262.296 527.481C262.393 527.784 262.226 528.108 261.924 528.205C261.621 528.301 261.297 528.135 261.201 527.832C260.258 524.885 259.283 521.636 258.279 518.103L258.004 517.133C255.935 509.782 253.765 501.326 251.528 491.977C248.817 480.649 246.134 468.564 243.584 456.432L243.076 454.005C242.349 450.52 241.674 447.227 241.058 444.174L239.582 436.744C239.522 436.432 239.726 436.131 240.038 436.07Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M261.544 565.49C309.682 567.76 363.772 562.85 363.772 562.85L361.87 549.299C361.87 549.299 303.769 550.865 262.654 551.597C261.782 558.095 261.544 565.49 261.544 565.49Z"
          fill="#4E5C93"
        />
        <path
          d="M308.042 563.504C308.351 563.537 308.575 563.814 308.542 564.123L308.448 565.041C308.374 565.793 308.291 566.67 308.201 567.663L308.01 569.856C307.819 572.113 307.63 574.562 307.451 577.172C306.538 590.472 306.124 604.015 306.488 616.648C306.866 629.737 308.066 640.908 310.228 649.557C310.303 649.859 310.12 650.164 309.818 650.239C309.517 650.315 309.212 650.131 309.136 649.83C306.951 641.088 305.743 629.844 305.364 616.681C304.999 604.006 305.413 590.428 306.328 577.095L306.511 574.534C306.675 572.307 306.846 570.215 307.017 568.28L307.193 566.346L307.423 564.003C307.453 563.725 307.68 563.516 307.951 563.501L308.042 563.504Z"
          fill="#253368"
        />
        <path
          d="M289.657 564.138C289.966 564.171 290.189 564.448 290.156 564.757L289.824 568.021C289.76 568.676 289.692 569.369 289.622 570.098L289.381 572.635C289.061 576.065 288.744 579.678 288.445 583.385L288.186 586.671C287.894 590.48 287.637 594.197 287.424 597.775L287.335 599.3C286.23 618.72 286.608 631.463 288.783 633.155C289.758 633.913 290.944 634.742 292.314 635.628C293.351 636.3 294.484 636.998 295.699 637.718C297.54 638.809 299.493 639.905 301.464 640.968L303.139 641.861L305.638 643.154C305.705 643.188 305.761 643.216 305.806 643.239C306.084 643.377 306.196 643.715 306.057 643.993C305.918 644.271 305.581 644.384 305.303 644.245L304.426 643.799L303.092 643.108C302.779 642.944 302.455 642.773 302.121 642.595C299.737 641.33 297.352 640.005 295.125 638.686C293.899 637.959 292.753 637.253 291.702 636.573C290.307 635.67 289.095 634.823 288.092 634.043C285.428 631.971 285.059 619.501 286.212 599.236C286.471 594.68 286.803 589.882 287.192 584.945L287.323 583.294C287.661 579.118 288.02 575.062 288.381 571.251L288.8 566.957L289.038 564.638C289.067 564.36 289.295 564.151 289.565 564.136L289.657 564.138Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M283.342 552.289V565.825C283.342 567.593 284.691 569.041 286.398 569.092C292.059 569.261 304.639 569.413 316.051 567.965C317.643 567.763 318.844 566.375 318.844 564.716V551.99C318.844 550.169 317.418 548.699 315.658 548.722C309.19 548.801 294.453 548.977 286.473 549.022C284.736 549.031 283.342 550.492 283.342 552.289Z"
          fill="#E4EBF7"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M287.004 554.625L287.007 563.586C287.007 564.755 288.108 565.713 289.502 565.746C294.12 565.857 304.383 565.952 313.694 564.992C314.993 564.857 315.972 563.937 315.972 562.839L315.969 554.415C315.968 553.211 314.804 552.239 313.368 552.252C308.091 552.308 296.067 552.429 289.557 552.461C288.14 552.468 287.004 553.436 287.004 554.625Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M315.873 566.721L285.903 553.345L287.14 550.621L317.359 564.244L315.873 566.721Z"
          fill="#E4EBF7"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M317.16 553.774L287.121 566.994L285.933 564.246L316.323 551.01L317.16 553.774Z"
          fill="#E4EBF7"
        />
        <path
          d="M292.214 404.183C292.53 404.214 292.761 404.495 292.73 404.812L292.644 405.809L292.579 406.659C292.536 407.252 292.494 407.895 292.454 408.584C292.033 415.75 292.038 423.401 292.75 430.567C293.044 433.527 293.454 436.298 293.988 438.846C294.054 439.157 293.854 439.462 293.543 439.528C293.232 439.593 292.927 439.394 292.862 439.083C292.319 436.491 291.903 433.68 291.605 430.681C290.886 423.446 290.881 415.738 291.305 408.517L291.368 407.51C291.389 407.186 291.41 406.875 291.432 406.576L291.57 404.866C291.576 404.8 291.581 404.745 291.585 404.699C291.613 404.415 291.844 404.199 292.12 404.181L292.214 404.183Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M162.97 641.852C161.468 626.726 172.1 613.082 187.135 610.843L335.047 588.799C355.307 585.781 373.972 600.325 375.995 620.708V620.71C378.019 641.093 362.576 659.023 342.118 660.046L192.758 667.508C177.577 668.266 164.471 656.978 162.97 641.852Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M195.77 617.026L282.863 601.078L195.589 576.946L124.028 597.339L195.77 617.026Z"
          fill="#ADC6FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M192.327 611.012L255.581 599.429L193.69 581.748L140.223 596.714L192.327 611.012Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M282.919 605.591L282.882 601.107L193.978 616.667L195.605 621.414L282.919 605.591Z"
          fill="#253368"
        />
        <path
          d="M181.665 586.031C181.724 585.859 181.894 585.757 182.067 585.779L182.141 585.796L232.553 602.911C232.749 602.978 232.854 603.191 232.788 603.387C232.729 603.558 232.559 603.66 232.386 603.638L232.312 603.621L181.9 586.506C181.704 586.44 181.599 586.227 181.665 586.031Z"
          fill="#ADC6FF"
        />
        <path
          d="M188.624 582.958L188.698 582.974L245.043 601.055C245.24 601.118 245.349 601.329 245.285 601.526C245.23 601.699 245.061 601.804 244.888 601.785L244.814 601.769L188.469 583.688C188.272 583.624 188.163 583.413 188.227 583.216C188.282 583.044 188.451 582.939 188.624 582.958Z"
          fill="#ADC6FF"
        />
        <path
          d="M181.02 590.593C181.081 590.422 181.253 590.323 181.425 590.347L181.499 590.365L223.85 605.401C224.045 605.47 224.147 605.685 224.078 605.88C224.017 606.051 223.846 606.15 223.673 606.126L223.599 606.108L181.248 591.072C181.053 591.002 180.951 590.788 181.02 590.593Z"
          fill="#ADC6FF"
        />
        <path
          d="M169.552 592.017C169.613 591.846 169.784 591.747 169.957 591.771L170.031 591.789L212.38 606.825C212.576 606.895 212.678 607.109 212.608 607.304C212.548 607.475 212.376 607.574 212.203 607.55L212.129 607.532L169.78 592.496C169.585 592.427 169.483 592.212 169.552 592.017Z"
          fill="#ADC6FF"
        />
        <path
          d="M158.977 594.081C159.038 593.91 159.21 593.81 159.382 593.835L159.456 593.853L201.806 608.889C202.001 608.958 202.103 609.172 202.034 609.368C201.973 609.538 201.801 609.638 201.628 609.614L201.555 609.596L159.205 594.56C159.01 594.49 158.908 594.276 158.977 594.081Z"
          fill="#ADC6FF"
        />
        <path
          d="M245.13 596.927C245.335 596.897 245.525 597.039 245.556 597.244C245.582 597.423 245.477 597.591 245.313 597.651L245.239 597.669L191.064 605.684C190.859 605.714 190.668 605.573 190.638 605.368C190.612 605.189 190.717 605.02 190.881 604.961L190.954 604.942L245.13 596.927Z"
          fill="#ADC6FF"
        />
        <path
          d="M232.974 592.968C233.179 592.938 233.369 593.079 233.4 593.284C233.426 593.463 233.321 593.632 233.157 593.691L233.083 593.71L178.909 601.724C178.705 601.755 178.514 601.613 178.484 601.408C178.457 601.229 178.562 601.061 178.726 601.001L178.8 600.982L232.974 592.968Z"
          fill="#ADC6FF"
        />
        <path
          d="M217.965 590.493C218.17 590.463 218.361 590.604 218.391 590.809C218.417 590.988 218.312 591.157 218.148 591.216L218.075 591.235L163.899 599.25C163.694 599.28 163.504 599.138 163.473 598.933C163.447 598.754 163.552 598.586 163.716 598.526L163.789 598.508L217.965 590.493Z"
          fill="#ADC6FF"
        />
        <path
          d="M207.679 583.218C207.884 583.188 208.074 583.329 208.105 583.534C208.131 583.713 208.026 583.882 207.862 583.941L207.788 583.96L153.613 591.974C153.408 592.005 153.217 591.863 153.187 591.658C153.161 591.479 153.266 591.311 153.43 591.251L153.503 591.232L207.679 583.218Z"
          fill="#ADC6FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M195.534 621.421L191.615 621.856L123.695 602.305L93.7024 489.01L166.656 501.752L195.534 621.421Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M191.474 621.866L119.85 601.282C119.196 601.094 118.688 600.575 118.512 599.917L89.5669 491.041C89.2024 489.673 90.3814 488.389 91.7764 488.633L160.979 500.818C161.738 500.951 162.345 501.523 162.527 502.271L191.474 621.866Z"
          fill="#4E5C93"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M268.084 585.161C293.069 579.56 352.243 568.922 384.715 555.539C384.715 555.539 418.208 540.755 405.151 511.278C392.422 482.538 358.949 499.295 358.949 499.295C321.088 517.239 277.301 539.577 255.842 548.856C255.842 548.856 244.583 554.391 248.228 569.606C252.553 587.658 268.084 585.161 268.084 585.161Z"
          fill="#FFC2BD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M348.834 521.004C348.834 521.004 334.972 455.703 334.06 443.838C333.262 433.458 334.108 406.017 361.992 401.733C384.291 398.307 395.458 414.94 400.053 428.737C407.995 452.574 408.447 484.149 408.72 512.883C408.72 512.883 410.155 545.499 378.748 546.78C352.17 547.864 348.834 521.004 348.834 521.004Z"
          fill="#FFC2BD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M342.206 487.506C340.186 476.874 333.188 447.662 332.9 443.922C332.102 433.542 334.249 404.552 362.132 400.268C384.431 396.842 395.723 414.9 400.319 428.697C403.489 438.209 406.621 468.576 407.869 479.882L342.206 487.506Z"
          fill="#597EF7"
        />
        <path
          d="M334.165 442.453C334.467 442.43 334.731 442.656 334.755 442.958L334.802 443.419C335.254 447.23 338.325 464.401 341.269 480.158L342.654 487.519L407.674 478.539C407.945 478.502 408.196 478.668 408.274 478.921L408.293 479.008C408.33 479.278 408.164 479.53 407.912 479.608L407.824 479.627L342.288 488.678C341.998 488.718 341.728 488.524 341.673 488.237L339.318 475.674C336.511 460.517 333.845 445.445 333.66 443.043C333.637 442.741 333.863 442.477 334.165 442.453Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M281.684 575.424C277.168 592.29 239.602 586.563 239.602 586.563L221.189 601.554C218.273 603.568 217.021 601.603 215.434 601.965C211.156 602.938 210.133 598.446 210.133 598.446C208.498 598.081 206.38 599.751 204.812 595.833C204.812 595.833 201.77 596.299 200.728 592.713C200.341 591.378 206.216 573.318 209.728 562.749C211.27 558.109 215.282 554.737 220.118 554.01L265.075 547.24C265.075 547.24 287.761 552.733 281.684 575.424Z"
          fill="#FFC2BD"
        />
        <path
          d="M242.478 575.062C242.841 574.906 243.261 575.075 243.417 575.439C243.558 575.769 243.431 576.146 243.134 576.329L243.04 576.378L229.686 582.081L216.38 600.401C216.168 600.692 215.779 600.777 215.47 600.615L215.38 600.56C215.089 600.348 215.004 599.959 215.166 599.65L215.222 599.56L228.645 581.08C228.702 581.002 228.774 580.936 228.857 580.886L228.943 580.843L242.478 575.062Z"
          fill="#D18888"
        />
        <path
          d="M233.478 569.48C233.822 569.286 234.259 569.408 234.453 569.752C234.629 570.065 234.544 570.454 234.269 570.668L234.18 570.727L221.917 577.634L211.073 596.603C210.895 596.915 210.517 597.042 210.192 596.915L210.097 596.869C209.785 596.691 209.658 596.313 209.785 595.989L209.831 595.893L220.773 576.753C220.821 576.669 220.886 576.596 220.962 576.538L221.043 576.485L233.478 569.48Z"
          fill="#D18888"
        />
        <path
          d="M224.769 564.303C225.079 564.058 225.529 564.111 225.774 564.421C225.997 564.702 225.974 565.1 225.735 565.354L225.657 565.426L217.394 571.96L207.507 592.303C207.35 592.626 206.982 592.778 206.649 592.673L206.551 592.634C206.228 592.477 206.076 592.109 206.181 591.776L206.22 591.678L216.18 571.186C216.211 571.122 216.252 571.062 216.301 571.01L216.38 570.938L224.769 564.303Z"
          fill="#D18888"
        />
        <path
          d="M325.022 589.184C325.329 589.14 325.614 589.354 325.657 589.662C325.697 589.939 325.527 590.197 325.269 590.277L325.179 590.298L274.559 597.451C274.251 597.494 273.966 597.28 273.923 596.973C273.884 596.696 274.053 596.438 274.312 596.357L274.401 596.337L325.022 589.184Z"
          fill="#253368"
        />
        <path
          d="M388.767 551.631C389.11 551.399 389.576 551.489 389.808 551.832C390.04 552.175 389.95 552.642 389.607 552.873C385.45 555.682 377.615 558.849 366.573 562.333L365.92 562.539C357.107 565.298 346.464 568.204 334.383 571.2C322.43 574.165 309.678 577.071 296.877 579.813L292.288 580.789C288.945 581.494 285.784 582.149 282.848 582.747L278.245 583.675L276.23 584.073L275.93 584.252C272.262 586.375 267.622 587.682 262.226 588.296L261.599 588.364C255.76 588.964 249.524 588.746 243.506 588.018L242.467 587.887C241.625 587.776 240.843 587.661 240.129 587.545L239.411 587.425L239.222 587.391L220.187 602.89C219.895 603.128 219.478 603.11 219.208 602.863L219.132 602.782C218.894 602.49 218.912 602.073 219.159 601.804L219.24 601.727L238.543 586.01C238.716 585.87 238.941 585.813 239.16 585.856L239.467 585.912C239.724 585.958 240.025 586.009 240.368 586.064L241.24 586.2C241.994 586.312 242.811 586.424 243.686 586.529C249.602 587.244 255.733 587.459 261.446 586.871C267.117 586.288 271.918 584.944 275.569 582.722C275.619 582.691 275.673 582.666 275.73 582.648L276.057 582.579L279.315 581.931L283.435 581.096C286.711 580.426 290.252 579.689 294.004 578.892C307.647 575.994 321.29 572.902 334.022 569.744L336.337 569.167C347.438 566.381 357.258 563.679 365.471 561.107L367.351 560.512C377.613 557.223 384.918 554.232 388.767 551.631Z"
          fill="#D18888"
        />
      </svg>
    </>
  )
}

export default ContactImage
